import { apiRequest } from './client';
import type { AlertEventRepository } from '../../application/ports/AlertEventRepository';
import type { AlertEvent } from '../../domain/AlertEvent';

export class HttpAlertEventRepository implements AlertEventRepository {
  listForDevice(deviceId: string, limit = 50) {
    return apiRequest<{ events: AlertEvent[] }>(`/devices/${deviceId}/alert-events?limit=${limit}`);
  }
}
